// removed by extract-text-webpack-plugin
module.exports = {"sectionTitleWrapper":"sectionTitleWrapper__13GbX","title":"title__60nrB"};


//////////////////
// WEBPACK FOOTER
// ./components/SectionTitle/style.css
// module id = vstC
// module chunks = 0